import styled from 'styled-components/macro';


const Container = styled.div`
    width: 100%;
    height: 100%;
    
    display: flex;
`;


export default Container;
